export const SIZE = [
  'large',
  '',
]
export const COLOR = [
  'danger',
  'warning',
  'good',
  '',
]
